import { useConfigurationContext } from "@/features/configuration/contexts/configuration-context";
import { usePrinter } from "@/components/print";
import { getVentaKudeTicketDatos } from "@/features/inventario/ventas/api/get-venta-kude-ticket-datos";
import { getKudeTicketDatos } from "@/features/facturacion-electronica/api/de-actions";
import { openPdfFromBase64 } from "@/features/facturacion-electronica/utils/pdf-utils";
import KudeTicketView from "@/features/facturacion-electronica/components/kude-ticket-print/kude-ticket-view";

export interface PrintKudeOptions {
    documentTitle: string;
    kudeBase64?: string;
    ventaId?: string;
    deId?: string;
}

export default function useKudePrinter() {
    const { modeTicket, printPaperWidth } = useConfigurationContext();
    const printer = usePrinter();

    async function printKude({ documentTitle, kudeBase64, ventaId, deId }: PrintKudeOptions) {
        if (modeTicket && (ventaId || deId)) {
            const response = ventaId
                ? await getVentaKudeTicketDatos(ventaId)
                : await getKudeTicketDatos(deId!);
            await printer.print({
                documentTitle,
                printComponent: <KudeTicketView datos={response.data} />,
                pageStyle: `@page { size: ${printPaperWidth} auto; margin: 0; }`
            });
        } else if (kudeBase64) {
            openPdfFromBase64(kudeBase64);
        }
    }

    return { printKude, Printer: printer.Printer };
}
